// extracted by mini-css-extract-plugin
export default {"container":"routeJourney_container__GNevg","stopItem":"routeJourney_stopItem__hpQS5","stopLabel":"routeJourney_stopLabel__ZZMwy"};